import React from "react";
import { getPaymentString, getTicketsPaymentString } from "../../../utils/checkout";
import { centsToCurrencyString } from "../../../utils/numbers";
import styled from "styled-components";

const PaymentMethodRow = styled.div`
  font-size: 0.8em;
  line-height: 1.75em;
`;

const PaymentMethodLogo = styled.img`
  vertical-align: middle;
  margin: -2px 0.5em 0;
`;

const PayPalLogo = styled(PaymentMethodLogo)`
  max-width: 70px;
`;

function ConfirmationPaymentInfo({data}) {
    const paymentMethodsString = getPaymentString(data.payment.methods);
    const bookingFee = data.payment.details.fees && data.payment.details.fees.booking || 0;
    const serviceFee = data.payment.details.fees && data.payment.details.fees.service || 0;
    const ticketsTotal = data.payment.details.tickets || 0;
    const candybarTotal = data.payment.details.candybar || 0;
    const subtotal = bookingFee + ticketsTotal + candybarTotal;

    return <div className="confirmation-info-block">
        {ticketsTotal > 0 && <p className="confirmation-info-row">
            <span className="confirmation-info-label">Boletos</span>
            {centsToCurrencyString(ticketsTotal)}
        </p>}
        
        {candybarTotal > 0 && <p className="confirmation-info-row">
            <span className="confirmation-info-label">Dulcería</span>
            {centsToCurrencyString(candybarTotal)}
        </p>}

        <p className="confirmation-info-row">
            <span className="confirmation-info-label">Costo por servicio</span>
            {centsToCurrencyString(bookingFee + serviceFee)}
        </p>

        <p className="confirmation-info-row">
            <span className="confirmation-info-label">Subtotal</span>
            {centsToCurrencyString(subtotal)}
        </p>

        <p className="confirmation-info-row">
            <span className="confirmation-info-label">Total pagado</span>
            {paymentMethodsString}
        </p>

        {('extra' in data.payment) && data.payment.extra.paypal && (
            <PaymentMethodRow>
                Pagado con
                <PayPalLogo src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_100x26.png" alt="PayPal Logo" />
                -
                Transacción {data.payment.extra.paypal}
            </PaymentMethodRow>
        )}
        {('extra' in data.payment) && data.payment.extra.masterpass && (
            <PaymentMethodRow>
                Pagado con
                <PaymentMethodLogo src="https://static.masterpass.com/dyn/img/acc/global/mp_mark_hor_blk.svg" alt="Masterpass Logo" />
            </PaymentMethodRow>
        )}
    </div>
}

export default ConfirmationPaymentInfo;